import { render, staticRenderFns } from "./mapping.vue?vue&type=template&id=03ca765e&scoped=true&"
import script from "./mapping.vue?vue&type=script&lang=js&"
export * from "./mapping.vue?vue&type=script&lang=js&"
import style0 from "./mapping.vue?vue&type=style&index=0&id=03ca765e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ca765e",
  null
  
)

export default component.exports